import QuantityInput from './QuantityInput';

export default QuantityInput;
